import {useEffect} from 'react';
import {useHistory} from 'react-router-dom';
import {getUrlPurePathName, getProjectType, getQueryVariable} from '@/utils';
import {
    clientItemProps,
    clientSideBar,
    managerItemProps,
    managerMyCompanySideBar,
    managerSideBar,
    publicCloudManager,
} from './sideBar';

interface listenParams {
  setUrlParamsStr: React.Dispatch<React.SetStateAction<string>>;
  setProjectId: React.Dispatch<React.SetStateAction<string>>;
  setSideBarSchema: React.Dispatch<React.SetStateAction<clientItemProps[]>>;
  setMenOpenKey: (schema: Array<clientItemProps | managerItemProps>) => void;
  setShowBar: React.Dispatch<React.SetStateAction<boolean>>;
}
const barMap = {
    'publicCloudManager': publicCloudManager,
    'secretManager': managerSideBar,
    'client': clientSideBar,
};

// 公有云会有一个这样的url 默认就展示公有云
const publicManagerIncludePath = [
    '#/idaas/landing/page',
];
export function useListen({
    setUrlParamsStr,
    setSideBarSchema,
    setMenOpenKey,
    setShowBar,
    setProjectId,
}: listenParams) {
    const history = useHistory();
    const currentBarName = getProjectType();
    function listen() {
        const path = getUrlPurePathName(location);
        // 管理员菜单设置url参数
        setUrlParamsStr(() => {
            const index = location.href.indexOf('?');
            if (index > 0) {
                return location.href.substring(Number(index) + 1, location.href.length);
            }
            return '';
        });

        // url不同会显示不同的title
        setProjectId(getQueryVariable('projectId'));
        /**
         *
         * ⚠注意【这块侧边栏逻辑比较复杂 后期会看看怎么写比较简单】
         *
         * 这里有三个侧边栏
         * 浦度客户端的侧边栏 和 公有云客户端的侧边栏 是有上下层级关系
         * --a
         * |--b
         * 浦度管理端和浦度客户端公用的路由是没有上下层级关系的
         * --a
         * --b
         * 浦端管理端点击我的企业 是原来san写的侧边栏
         * 因此是三个侧边栏的切换
        */
        if (['publicCloudManager', 'secretManager'].includes(currentBarName)) {

            // 浦度的管理端和私有云的管理端 有两个不同的侧边栏
            const hasManagerPath = (barMap[currentBarName] as managerItemProps[])
                .reduce((pre: string[], cur: managerItemProps) => {
                    if (cur.includePath) {
                        pre.push(...cur.includePath);
                    }
                    pre.push(cur.key);
                    return pre;
                }
                , []).includes(path);
            const hasManagerMyCompany = managerMyCompanySideBar
                .reduce((pre: string[], cur) => {
                    const children = (cur as clientItemProps).children;
                    if (children) {
                        const pathArr = children.map(item => [item.key, ...(item.includePath || [])]).flat();
                        pre.push(...pathArr);
                    } else {
                        pre.push(...((cur as managerItemProps).includePath || []));
                    }
                    pre.push(cur.key);
                    return pre;
                }, [])
                .includes(path);
            // 既没有命中管理端路由 也没有命中我的企业里面的路由 默认展示管理端
            if (hasManagerPath || publicManagerIncludePath.includes(location.hash)) {
                setSideBarSchema(() => barMap[currentBarName] as clientItemProps[]);
                setMenOpenKey(barMap[currentBarName]);
            } else if (hasManagerMyCompany) {
                setSideBarSchema(() => managerMyCompanySideBar as clientItemProps[]);
                setMenOpenKey(managerMyCompanySideBar);
            } else {
                history.push('/idaas/#/idaas/project/list');
            }
        } else {
            setSideBarSchema(() => clientSideBar);
            setMenOpenKey(clientSideBar);
        }

        if (path.startsWith('/idaas/reset-pass')) {
            setShowBar(false);
        }
    }
    useEffect(() => {
        listen();
        const unlinsten = history.listen(listen);
        return unlinsten;
    }, []
    );
}
